import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {Input, Select, Popover} from 'antd'
import {debounce} from 'throttle-debounce'

import style from './tradeSelect.sass'

@observer
class TradeSelect extends Component {
  state = {
    open: false,
    closing: false
  }
  handleChange = (value) => {
    this.props.changeHandler(`${this.props.type}_type`, value)
  }
  handleInputChange = (e) => {
    const {name, value} = e.target
    this.props.changeHandler(name, value)
  }
  handleDropdownVisibleChange = debounce(100, (open) => {
    this.setState({open})
  })
  render() {
    const {type, value, tradeValue, hasCoin} = this.props
    let options
    if (hasCoin) {
      options = type === 'trade' ? crypto_trade_choices : crypto_cover_trade_choices
    } else {
      options = type === 'trade' ? shares_trade_choices : shares_cover_trade_choices
    }
    const currentValue = options.find(row => row.value === value)
    const hasNumberInput = currentValue?.text.indexOf('X') !== -1
    const addonBefore = (
      <Select
        value={value}
        optionLabelProp='label'
        showArrow={false}
        dropdownRender={() => <span/>}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        open={this.state.open}
        className={style.before}
      >
        {options.map(opt =>
          <Select.Option key={opt.value} label={opt.text.substring(0, opt.text.indexOf('X'))} value={opt.value}>
            {tradeValue
              ? opt.text.replace('X', tradeValue)
              : opt.text
            }
          </Select.Option>
        )}
      </Select>
    )
    const addonAfter = (
      <Select
        value={value}
        optionLabelProp='label'
        dropdownRender={() => <span/>}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        open={this.state.open}
      >
        {options.map(opt =>
          <Select.Option key={opt.value} label={opt.text.substring(opt.text.indexOf('X') + 1)} value={opt.value}>
            {tradeValue
              ? opt.text.replace('X', tradeValue)
              : opt.text
            }
          </Select.Option>
        )}
      </Select>
    )
    if (hasNumberInput) {
      return(
        <div styleName='wrapper'>
          <Input
            type='number'
            name={`${type}_value`}
            className={style.container}
            size='large'
            addonBefore={addonBefore}
            addonAfter={addonAfter}
            value={tradeValue}
            onChange={this.handleInputChange}
          />
          <Select
            value={value}
            open={this.state.open}
            size='large'
            styleName='invisible'
            onChange={this.handleChange}
          >
            {options.map(opt => {
              const value = tradeValue
                ? opt.text.replace('X', tradeValue)
                : opt.text
              return(
                <Select.Option key={opt.value} value={opt.value} styleName='option'>
                  {opt.tooltip
                    ? <Popover content={opt.tooltip} placement='bottom' styleName='popover'>
                      {value}
                    </Popover>
                    : <span>{value}</span>
                  }
                </Select.Option>
              )
            })}
          </Select>
        </div>
      )
    } else {
      return(
        <Select
          value={value}
          size='large'
          onChange={this.handleChange}
          styleName='select'
        >
          {options.map(opt => {
            const value = tradeValue
              ? opt.text.replace('X', tradeValue)
              : opt.text
            return(
              <Select.Option key={opt.value} value={opt.value} styleName='option'>
                {opt.tooltip
                  ? <Popover content={opt.tooltip} placement='bottom' styleName='popover'>
                    {value}
                  </Popover>
                  : <span>{value}</span>
                }
              </Select.Option>
            )
          })}
        </Select>
      )
    }
  }
}

export default TradeSelect

const shares_trade_choices = [{
  value: 'num_of_shares',
  text: 'Buy X shares at open'
}, {
  value: 'num_of_shares_close',
  text: 'Buy X shares at close'
}, {
// Just commented out in case we need the options later
//   value: 'percentage_of_portfolio',
//   text: 'Buy with X% of portfolio at open'
// }, {
//   value: 'percentage_of_portfolio_close',
//   text: 'Buy with X% of portfolio at close'
// }, {
  value: 'sell_num_of_shares',
  text: 'Sell X shares at open'
}, {
  value: 'sell_num_of_shares_close',
  text: 'Sell X shares at close'
// }, {
//   value: 'sell_percentage_of_portfolio',
//   text: 'Sell with X% of portfolio at open'
// }, {
//   value: 'sell_percentage_of_portfolio_close',
//   text: 'Sell with X% of portfolio at close'
}]

const shares_cover_trade_choices = [{
  value: 'all',
  text: 'Close all'
}, {
  value: 'num_of_shares',
  text: 'Close X number of shares'
}, {
  value: 'percentage_of_positions',
  text: 'Close X% of positions',
  tooltip: 'Close X% of positions will only close X% of the last trade you made NOT X% of your entire position in the stock.'
}]

const crypto_trade_choices = [{
  value: 'num_of_shares',
  text: 'Buy X coins at midnight'
}, {
  value: 'sell_num_of_shares',
  text: 'Sell X coins at midnight'
}]

const crypto_cover_trade_choices = [{
  value: 'all',
  text: 'Close all'
}, {
  value: 'num_of_shares',
  text: 'Close X number of coins'
}, {
  value: 'percentage_of_positions',
  text: 'Close X% of positions',
  tooltip: 'Close X% of positions will only close X% of the last trade you made NOT X% of your entire position in the coins.'
}]
